module.exports = __webpack_public_path__ + "static/media/sergey-zolkin-1045-unsplash-min.b65719e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sergey-zolkin-1045-unsplash-min.jpg
// module id = 107
// module chunks = 0